<template>
  <CSidebar 
    v-if="minimize != undefined"
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => {$store.commit('set', ['sidebarShow', value])}"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
    
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        :height="350" 
        viewBox="-35 0 236 34"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import store from '../store'
import { mapActions } from 'vuex'
import nav from './_nav'

export default {
  name: 'Sidebar',
  nav,
  computed: {
    show () {
      return store.state.sidebarShow 
    },
    minimize () {
      return store.state.sidebarMinimize 
    }
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
    })
  },
  mounted() {
    const vm = this

    // Event listener handles logout when user clicks logout button in sidebar, generated from nav.js
    this.$nextTick(() => {
      
      const logoutButton = document.getElementsByClassName('sidebar-logout-btn')[0];
      logoutButton.addEventListener('click', vm.logout);
    });
  }
}
</script>

<style lang="scss">
.c-sidebar-nav-icon {
  height: 25px;
}
.c-sidebar {
  background-color: #471747;
}
.c-sidebar-nav-link:hover {
  background-color: green !important;
}
</style>
